export default __webpack_public_path__ + "static/media/filler.12162768.svg";